/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  checkValidMobileNumber,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import IntlMuliCityEmailCard from './IntlMultiCityEmailCard';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { getUserDetails } from '../../api/profileApi';
import { useAppContext } from '../../saas/AppConfigWrapper';

function RoundTripIntlWhatsAppModal({
  searchRequest,
  selectedFlights,
  onSend,
}) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [selectedFares, setSelectedFares] = useState(
    selectedFlights.map((d) => {
      return d.fare.totalfq;
    }),
  );

  const PREF_CLASS_DICT = {
    Y: 'Economy',
    W: 'Premium Economy',
    C: 'Business',
    F: 'First Class',
  };

  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const getOnwardDate = (index) => {
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    return newDatesArray[index];
  };

  const handleSend = async () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    let fromEmail = '';
    let contactNum = '';
    let companyName = '';
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      contactNum = User.ContactNumber;
      companyName = User.Company;
    }
    let msg = '';
    const airplaneEmoji = '✈️';
    selectedFlights.forEach((flt, fltIndex) => {
      msg += `Option ${fltIndex + 1} --->\n\n`;
      flt.flights.forEach((fltOption, fltOptionIndex) => {
        msg += `Trip ${fltOptionIndex + 1} --->\n`;
        fltOption.flightlegs.forEach((leg, index) => {
          msg += ` ${airplaneEmoji} ${
            leg.validatingcarriername
          } ${leg.carrier.substring(0, 2)} - ${leg.flightnumber} | ${
            leg.origin_name
          } - ${formatDate(
            getNewDate(leg.depdate),
            DATE_MONTH_YEAR_VIEW_FORMAT,
          )} ${formatTimeString(leg.deptime)} --> ${
            leg.destination_name
          } - ${formatDate(
            getNewDate(leg.arrdate),
            DATE_MONTH_YEAR_VIEW_FORMAT,
          )} ${formatTimeString(leg.arrtime)}\n`;
        });
        msg += `Stops : ${
          fltOption.flightlegs.length !== 1
            ? fltOption.flightlegs.length - 1
            : 'Non'
        } Stop\n`;
      });
      if (showBreakup) {
        msg += `${flt.fare.faretype} Fare : ${
          appConfig?.appCurrency
        } ${getAmount(selectedFares[fltIndex])}/ ${
          flt.fare.refundableinfo === 'Y' ? 'Refundable' : 'Non-Redundable'
        }\n`;
      }
      msg += '------------------------------------------\n';
    });
    msg += `👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻\n\nThank you for choosing ${companyName}\nIn case of any urgent support : \n`;
    msg += `☎ Contact : ${contactNum}\n✉ Email : ${fromEmail}\n`;
    onSend(whatsappNumber, msg);
    setIsLoading(false);
  };

  const handleAddMarkup = (val) => {
    setMarkupToBeAdded(val);
  };
  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="fs-14">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row className="mt-3">
          <Col lg={5} md={5} sm={12} xs={12}>
            <AppNumberInput
              name="whatsappNumber"
              label="Enter Mobile Number"
              placeholderText="Enter Customer No"
              value={whatsappNumber}
              onChange={(value) => setWhatsappNumber(value)}
              errorText={validationError && 'Please Enter Mobile Number'}
            />
            {checkValidMobileNumber(whatsappNumber) && validationError && (
              <small className="app-error-text">Enter Valid Number</small>
            )}
          </Col>
          <Col lg={5} md={6} sm={6} xs={12}>
            <AppNumberInput
              name="markUpToBeAdded"
              label="Markup"
              value={markUpToBeAdded}
              onChange={(d) => handleAddMarkup(d)}
            />
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div className="overflow-auto " style={{ height: '300px' }}>
          <div id="emialContent">
            <div
              style={{
                width: '750px',
                color: '#000',
                padding: '1rem',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <div
                className="show-no-border-in-mobile overflow-hidden"
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                }}
              >
                <div
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    color: '#fff',
                    backgroundColor: appConfig?.clientPrimaryColor,
                    fontSize: '14px',
                  }}
                >
                  <div
                    style={{
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '16px',
                      padding: '16px',
                      fontSize: '12px',
                      borderBottom: '1px solid #ccc',
                    }}
                    className="d-none"
                  >
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ fontSize: '12px' }}>Journeys: </div>
                            {searchRequest.origin.split(':').map((d, index) => (
                              <div
                                key={d}
                                style={{ fontWeight: '600', fontSize: '14px' }}
                              >
                                {`${d} - ${
                                  searchRequest.destination.split(':')[index]
                                } | ${formatDate(
                                  getNewDate(getOnwardDate(index)),
                                  ONLY_DATE_MONTH_FORMAT,
                                )}`}
                              </div>
                            ))}
                          </td>
                          <td>
                            <table style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: 'end',
                                      fontSize: '12px',
                                    }}
                                  >
                                    Traveler Class :{' '}
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {PREF_CLASS_DICT[searchRequest.prefclass]}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'end' }}>
                                    Passenger(s):{' '}
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {parseInt(searchRequest.numadults, 10)}{' '}
                                      Adult
                                      {parseInt(searchRequest.numchildren, 10) >
                                        0 &&
                                        ` ${parseInt(
                                          searchRequest.numchildren,
                                          10,
                                        )} Child`}
                                      {parseInt(searchRequest.numinfants, 10) >
                                        0 &&
                                        ` ${parseInt(
                                          searchRequest.numinfants,
                                          10,
                                        )} Infant`}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {selectedFlights.map((selectedFlight, index) => (
                  <React.Fragment key={index}>
                    <div
                      style={{
                        padding: '5px 10px',
                        color: '#000',
                        fontWeight: '600',
                        borderBottom: '1px solid #000',
                      }}
                    >
                      Option - {index + 1}
                    </div>
                    <IntlMuliCityEmailCard
                      key={selectedFlight.fare.nextraflightkey}
                      flight={selectedFlight.flights}
                      isLast={index === selectedFlights.length - 1}
                      index={index}
                      markUpToBeAdded={markUpToBeAdded}
                      showHideFare={showBreakup}
                      fare={selectedFlight.fare}
                      searchRequest={searchRequest}
                      showInput={setShowBreakup}
                      onFareUpdate={() => {}}
                    />
                  </React.Fragment>
                ))}
                <div
                  style={{
                    backgroundColor: '#333333',
                    borderTop: '1px solid #ccc',
                    color: '#fff',
                    padding: '10px',
                    fontSize: '12px',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px',
                  }}
                  className="d-none"
                >
                  <span style={{ fontSize: '14px', marginBottom: '10px' }}>
                    Terms & Conditions:
                  </span>
                  <ul>
                    <li>
                      All Travel timings are as per the local time in 24hrs
                      format
                    </li>
                    <li>
                      Check passenger name and Travel Itinerary details
                      carefully
                    </li>
                    <li>
                      Names provided should be with Valid Government Approved
                      Photo ID/ Passport
                    </li>
                    <li>
                      Automated Ticketing time limit provided as per airline
                    </li>
                    <li>
                      Ensure Sufficient Funds are available for confirmation of
                      services
                    </li>
                    <li>
                      Fares and Taxes are subject to availability at the time of
                      issuance
                    </li>
                    <li>
                      We are not liable if any increase occurs due to ROE
                      fluctuation and taxes
                    </li>
                    <li>
                      Check all Visa requirement for Destination and Transit
                      country with the respective airline and embassy
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handleSend}
          btnText="Share in Whatsapp"
        />
      </div>
    </div>
  );
}

RoundTripIntlWhatsAppModal.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedFlights: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default RoundTripIntlWhatsAppModal;
